module.exports = __webpack_public_path__ + "img/homenew.ea3fa917.png";